import {
    NUMBER_ORDERED_RECORDS
} from "./constants"

const INIT_STATE = {
    numberOrderedRecords: []
}

/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case NUMBER_ORDERED_RECORDS:
            return {
                ...state,
                numberOrderedRecords: action.payload,
            };
        default:
            return state;
    }
};